/* src/messages/Scene.js */

import React from 'react';

// import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import MessageCard from './cards/MessageCard';
import MessageListCard from './cards/MessageListCard';

const Messages = () => (
  <Grid container spacing={16}>
    <Grid item xs={12} md={4}>
      <MessageListCard innerRef={node => this.list = node} />
    </Grid>
    <Grid item xs={12} md={8}>
      <MessageCard save={id => this.list.getWrappedInstance()._save(id)} />
    </Grid>
  </Grid>
);

export default Messages;



// WEBPACK FOOTER //
// ./src/modules/messages/Scene.js